module.exports = __webpack_public_path__ + "static/media/shuttleScheduleIcon.1af631ec.png";